export default __webpack_public_path__ + "static/media/releaseNotes.06185352.md";